// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vmOptionContainer__da5 {
  display: flex;
  align-items: flex-end;
}

.vmOptionContainer__da5:has(div > div[class*='error']) {
  display: flex;
  align-items: center;
}

.hiddenButton__a80 {
  visibility: hidden;
}

.addVmOptionButton__fd1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
}

.errorText__be5 {
  color: var(--ring-error-color);
  text-align: justify;
}
`, "",{"version":3,"sources":["webpack://./src/pages/profiles/profile-details/profile-ide-provisioner/settings/vm-options/vm-options-field-array.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":[".vmOptionContainer {\n  display: flex;\n  align-items: flex-end;\n}\n\n.vmOptionContainer:has(div > div[class*='error']) {\n  display: flex;\n  align-items: center;\n}\n\n.hiddenButton {\n  visibility: hidden;\n}\n\n.addVmOptionButton {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0;\n}\n\n.errorText {\n  color: var(--ring-error-color);\n  text-align: justify;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vmOptionContainer": `vmOptionContainer__da5`,
	"hiddenButton": `hiddenButton__a80`,
	"addVmOptionButton": `addVmOptionButton__fd1`,
	"errorText": `errorText__be5`
};
export default ___CSS_LOADER_EXPORT___;
